// 时间戳
export function formatDate(date,fmt){
    if(/(y+)/.test(fmt)){
        fmt = fmt.replace(RegExp.$1, (date.getFullYear()+'').substr(4-RegExp.$1.length));
    }
    let o = {
        'M+': date.getMonth()+1,
        'd+': date.getDate(),
        'h+': date.getHours(),
        'm+': date.getMinutes(),
        's+': date.getSeconds()
    }
    for(let k in o){    
        let str = o[k]+'';
        if(new RegExp(`(${k})`).test(fmt)){
            fmt = fmt.replace(RegExp.$1, (RegExp.$1.length===1)?str:padLeftZero(str));
        }
    }
    return fmt;
};
function padLeftZero(str){
    return ('00'+str).substr(str.length);
}

// 时区
export function formatTime(t,utc){
    //t传入的时间参数,utc传入的时区参数
    if(!t) return;
    //获取本地时间
    var d=new Date();
    //获得本地时区
    utc=utc?parseFloat(utc):d.getTimezoneOffset()/60;
    //格式化传入时间
    var time=new Date(t);
    //转换传入时间为本地时间（默认传入服务器时间为东八区时间）
    time.setHours(time.getHours()+(utc-8));
    //输出时间
    var yy=time.getFullYear();
    var MM=time.getMonth()+1;
    MM=MM<10?'0'+MM:MM;
    var dd=time.getDate();
    dd=dd<10?'0'+dd:dd;
    var hh=time.getHours();
    hh=hh<10?'0'+hh:hh;
    var mm=time.getMinutes();
    mm=mm<10?'0'+mm:mm;
    var ss=time.getSeconds();
    ss=ss<10?'0'+ss:ss;
    var date=yy+'-'+MM+'-'+dd+' '+hh+':'+mm+':'+ss;
    return date;
}


// WEBPACK FOOTER //
// ./src/util/format.js